var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lottery-draw"},[_c('div',{staticClass:"lottery-draw-wrapper"},[_c('TemporaryDrawnNumber',{attrs:{"retail":"","temp-drawn-number":_vm.tempDrawnNumber}})],1),_c('DrawnNumbersBox',{attrs:{"retail":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }